import React from 'react'
import PropTypes from 'prop-types'
import {
  DEFAULT_PRIMARY_COLOR_CODE,
  DEFAULT_SECONDARY_COLOR_CODE
} from '../../constants/general'

const Avatar5 = (props) => {
  const {
    fillLight = DEFAULT_PRIMARY_COLOR_CODE,
    fillDark = DEFAULT_SECONDARY_COLOR_CODE,
    stroke = DEFAULT_SECONDARY_COLOR_CODE,
    className = "",
    ...others
  } = props

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 1000"
      className={className}
      {...others}
    >
      <rect
        x={176.92}
        y={176.92}
        width={646.15}
        height={646.15}
        rx={111.77}
        transform="rotate(45 500.004 499.998)"
        fill={fillLight}
      />
      <circle
        className="cls-2"
        cx={571.52} cy={434.33} r={27.69}
        fill="none"
        stroke={stroke}
        strokeWidth="25px"
        strokeMiterlimit="10"
      />
      <circle
        className="cls-3"
        cx={768.38} cy={500.38} r={27.69}
        fill={fillDark}
      />
      <circle
        className="cls-2"
        cx={434.33} cy={434.33} r={27.69}
        fill="none"
        stroke={stroke}
        strokeWidth="25px"
        strokeMiterlimit="10"
      />
      <path
        className="cls-2"
        d="M359.84 545.14H640.16V623.93H359.84z"
        fill="none"
        stroke={stroke}
        strokeWidth="25px"
        strokeMiterlimit="10"
      />
      <path
        className="cls-2"
        d="M669.45 500.38L756.6 500.38"
        fill="none"
        stroke={stroke}
        strokeWidth="25px"
        strokeMiterlimit="10"
      />
      <circle
        className="cls-3"
        cx={229.85} cy={499.22} r={27.69}
        fill={fillDark}
      />
      <path
        className="cls-2"
        d="M328.42 499.22L241.63 499.22"
        fill="none"
        stroke={stroke}
        strokeWidth="25px"
        strokeMiterlimit="10"
      />
      <path
        className="cls-2"
        d="M500 545.14L500 623.93"
        fill="none"
        stroke={stroke}
        strokeWidth="25px"
        strokeMiterlimit="10"
      />
      <path
        className="cls-2"
        d="M434.33 545.14L434.33 623.93"
        fill="none"
        stroke={stroke}
        strokeWidth="25px"
        strokeMiterlimit="10"
      />
      <path
        className="cls-2"
        d="M571.52 545.14L571.52 623.93"
        fill="none"
        stroke={stroke}
        strokeWidth="25px"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

Avatar5.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  className: PropTypes.string
}

export default Avatar5
